import axios from "axios";
import { useEffect, useState, useRef } from "react";
import clusterMasterResultType from "../model/ClusterMasterResultType";
import Result from "../components/ClusterMasterResult";
import Header from "../components/Header";
import PageSelect from "../components/PageSelect";
import ExcelJS from 'exceljs';
import "./ClusterMaster.css";

const ClusterMaster = () => {

    const [apiKey, setApikey] = useState<string>("");
    const [id, setId] = useState<string>("");
    const [per_page, setPer_Page] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [parent_id, setParent_id] = useState<string>("");
    const [tag, setTag] = useState<string>("");
    const [cm_per_pixel, setCmPer] = useState<string>("");
    const [att_coef, setAtt] = useState<string>("");
    const [enabled, setEnabled] = useState<string>("");
    const [created_gt, setCreated_gt] = useState<string>("");
    const [created_lt, setCreated_lt] = useState<string>("");
    const [updated_gt, setUpdated_gt] = useState<string>("");
    const [updated_lt, setUpdated_lt] = useState<string>("");
    const [sort, setSort] = useState<string>("");
    const [pageNo, setPageNo] = useState<number>(0);
    const [lastPageNo, setLastPageNo] = useState<number>(0);
    const [total, setTotal] = useState<number>(-1);
    const [result, setResult] = useState<clusterMasterResultType[]>([]);
    const results: clusterMasterResultType[] = [];
    const [csvResult, setCSVResult] = useState<clusterMasterResultType[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);   // CSV全件取得
    const [isFetching, setIsFetching] = useState<boolean>(false); // 検索・ページング
    const [isNoCheck, setNoCheck] = useState<boolean>(false);
    var apiUrl:string = "";

    // ---- UI-only state ----
    const [filterOpen, setFilterOpen] = useState<boolean>(true);
    const [csvOpen, setCsvOpen] = useState<boolean>(false);
    const csvRef = useRef<HTMLDivElement>(null);

    const checkLocoEnv = () => {
      if (localStorage.getItem("locoEnv") === "prod") {
        apiUrl = "https://api.bc-loco.jp/api/clusters"
      } else {
        apiUrl = "http://stg.api.bc-loco.jp/api/clusters"
      }
    }

    const getCluster = async(e: any, pageNo: number) => {
        e.preventDefault();
        saveParams();
        saveApikey();
        checkLocoEnv();
        setIsFetching(true);
        try {
        await axios.get(apiUrl,
        {
          headers: {
              "Authorization": apiKey,
              "Content-Type": "application/json"
          },
          params: {
              ...(id ? {id: id} : {}),
              ...(pageNo ? {page: pageNo} : {}),
              ...(per_page ? {per_page: per_page} : {}),
              ...(name ? {name: name} : {}),
              ...(parent_id ? {parent_id: parent_id} : {}),
              ...(tag ? {tag: tag} : {}),
              ...(cm_per_pixel ? {cm_per_pixel: cm_per_pixel} : {}),
              ...(att_coef ? {att_coef: att_coef} : {}),
              ...(enabled ? {enabled: enabled} : {}),
              ...(created_gt ? {created_gt: created_gt.replace("T", " ")} : {}),
              ...(created_lt ? {created_lt: created_lt.replace("T", " ")} : {}),
              ...(updated_gt ? {updated_gt: updated_gt.replace("T", " ")} : {}),
              ...(updated_lt ? {updated_lt: updated_lt.replace("T", " ")} : {}),
              ...(sort ? {sort: sort} : {})
          }
        })
        .then(async res => {
          console.log(res);
          if(res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
            return
          } else if(res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
            return
          }
          const items = JSON.parse(JSON.stringify(res.data.payload))
          if (items.total > 100000) {
            alert("10万件を超えるデータは表示出来ません。 総件数:" + items.total + "\n日付範囲を調整して下さい。")
            return
          }
          setTotal(items.total)
          setPageNo(items.current_page)
          setLastPageNo(items.last_page)

          items.data.forEach((value: clusterMasterResultType, index: number) => {

            let beacons: string[] = []
            value.beacons.forEach((beacon: any , beaocon_index: number) => {
                beacons[beaocon_index] = "id: " + beacon.id
            })

            let resultbuf: clusterMasterResultType = {
                no: 0,
                id: value.id,
                name: value.name,
                tag: value.tag,
                image: value.image,
                cm_per_pixel: value.cm_per_pixel,
                att_coef: value.att_coef,
                parent_id: value.parent_id,
                beacons: beacons,
                created: value.created,
                updated: value.updated,
                enabled: value.enabled
            }

            results.push(resultbuf)

            console.log("beacons:" + results[index].beacons[0])
            results[index].no = items.from;
            items.from++;
          })
          setResult(results)
        })
        .catch(err =>
          alert("エラーが発生しました。" + err)
        )
        } finally {
          setIsFetching(false);
        }
    }

    const createCSV = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {

      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("ClusterMaster");
      const worksheet = workbook.getWorksheet("ClusterMaster");
      const columns: Partial<ExcelJS.Column>[] = [];

      if (isNoCheck) {
        columns.push({ header: "no", key: "no" })
      }
      columns.push({ header: "id", key: "id" })
      columns.push({ header: "name", key: "name" })
      columns.push({ header: "tag", key: "tag" })
      columns.push({ header: "image", key: "image" })
      columns.push({ header: "cm_per_pixel", key: "cm_per_pixel" })
      columns.push({ header: "att_coef", key: "att_coef" })
      columns.push({ header: "parent_id", key: "parent_id" })
      columns.push({ header: "beacons", key: "beacons" })
      columns.push({ header: "created", key: "created" })
      columns.push({ header: "updated", key: "updated" })
      columns.push({ header: "enabled", key: "enabled" })

      worksheet.columns = columns;
      setIsLoading(true);
      if (await getAllCluster(e, 1) == true ) {

        csvResult.forEach((value: clusterMasterResultType) => {
          worksheet.addRow(value);
        });

        csvResult.length = 0;

        console.log("Row Count:" + worksheet.rowCount)
        setIsLoading(false);

        try {
          const uint8Array = await workbook.csv.writeBuffer();
          const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          setTimeout(()=> {
            a.href = url;
            a.download = "clusterMaster_" + getNowDate() +  ".csv";
            a.click();
            a.remove();
          },1000)

        } catch (error) {
          console.error(error);
        }
      } else {
        setIsLoading(false);
      }
    }

    const getAllCluster = async(e: any, pageNo: number) => {
      let ret = true;
      e.preventDefault();
      checkLocoEnv();
      await axios.get(apiUrl,
      {
        headers: {
            "Authorization": apiKey,
            "Content-Type": "application/json"
        },
        params: {
            ...(id ? {id: id} : {}),
            ...(pageNo ? {page: pageNo} : {}),
            ...({per_page: 1000}),
            ...(name ? {name: name} : {}),
            ...(parent_id ? {parent_id: parent_id} : {}),
            ...(tag ? {tag: tag} : {}),
            ...(cm_per_pixel ? {cm_per_pixel: cm_per_pixel} : {}),
            ...(att_coef ? {att_coef: att_coef} : {}),
            ...(enabled ? {enabled: enabled} : {}),
            ...(created_gt ? {created_gt: created_gt.replace("T", " ")} : {}),
            ...(created_lt ? {created_lt: created_lt.replace("T", " ")} : {}),
            ...(updated_gt ? {updated_gt: updated_gt.replace("T", " ")} : {}),
            ...(updated_lt ? {updated_lt: updated_lt.replace("T", " ")} : {}),
            ...(sort ? {sort: sort} : {})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return ret = false
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return ret = false
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        if (items.total > 100000) {
          alert("10万件を超えるデータは出力出来ません。 総件数:" + items.total + "\n日付範囲を調整して下さい。")
          return ret = false
        }
        let csvArrayCount = csvResult.length;

        items.data.forEach((value: clusterMasterResultType, index: number) => {

          let beacons: string[] = []
            value.beacons.forEach((beacon: any , beaocon_index: number) => {
                beacons[beaocon_index] = "id: " + beacon.id
            })

            let resultbuf: clusterMasterResultType = {
                no: 0,
                id: value.id,
                name: value.name,
                tag: value.tag,
                image: value.image,
                cm_per_pixel: value.cm_per_pixel,
                att_coef: value.att_coef,
                parent_id: value.parent_id,
                beacons: beacons,
                created: value.created,
                updated: value.updated,
                enabled: value.enabled
            }
          csvResult.push(resultbuf);
          csvResult[index + csvArrayCount].no = items.from;
          items.from++;
        })
        setCSVResult(csvResult);
        if (items.current_page != items.last_page) {
          await getAllCluster(e, items.current_page + 1);
        } else {
          console.log("getall: " + csvResult.length);
        }
      })
      .catch(err =>
        alert("エラーが発生しました。" + err)
      )
      return ret
  }

  const changeCreatedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setCreated_gt(value);
  }
  const changeCreatedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setCreated_lt(value);
  }
  const changeUpdateGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setUpdated_gt(value);
  }
  const changeUpdateLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setUpdated_lt(value);
  }

  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    return y + m + d;
  }

  type clusterParamsType = {
    id?: string, perpage?: string, page?: number, name?: string, parent_id?: string, tag?: string,
    image?: string, cm_per_pixel?: string, att_coef?: string, enabled?: string,
    created_gt?: string, created_lt?: string, updated_gt?: string, updated_lt?: string, sort?: string
  }

  const saveParams = () => {
    let params: clusterParamsType = {};
    params.id = id ? id : "";
    params.perpage = per_page ? per_page : "";
    params.name = name ? name : "";
    params.parent_id = parent_id ? parent_id : "";
    params.tag = tag ? tag : "";
    params.cm_per_pixel = cm_per_pixel ? cm_per_pixel : "";
    params.att_coef = att_coef ? att_coef : "";
    params.enabled = enabled ? enabled : "";
    params.created_gt = created_gt ? created_gt : "";
    params.created_lt = created_lt ? created_lt : "";
    params.updated_gt = updated_gt ? updated_gt : "";
    params.updated_lt = updated_lt ? updated_lt : "";
    params.sort = sort ? sort : "";

    let json = JSON.stringify(params);
    console.log("params:" + json);
    localStorage.setItem("locoClusterMasterParams", json)
  }

  const saveApikey = () => {
    localStorage.setItem("locoApikey", apiKey ? apiKey : "" );
  }

  const loadParams = () => {
    const paramsJson = localStorage.getItem("locoClusterMasterParams")
    if (paramsJson != null) {
      const params:clusterParamsType = JSON.parse(paramsJson as string)
      setId(params.id ? params.id : "");
      setPer_Page(params.perpage ? params.perpage : "");
      setName(params.name ? params.name : "");
      setParent_id(params.parent_id ? params.parent_id : "");
      setTag(params.tag ? params.tag : "");
      setCmPer(params.cm_per_pixel ? params.cm_per_pixel : "");
      setAtt(params.att_coef ? params.att_coef : "");
      setEnabled(params.enabled ? params.enabled : "");
      setCreated_gt(params.created_gt ? params.created_gt : "");
      setCreated_lt(params.created_lt ? params.created_lt : "");
      setUpdated_gt(params.updated_gt ? params.updated_gt : "");
      setUpdated_lt(params.updated_lt ? params.updated_lt : "");
      setSort(params.sort ? params.sort : "");
    }
  }

  const loadApikey = () => {
    const locoApikey = localStorage.getItem("locoApikey")
    if (locoApikey != null) { setApikey(locoApikey ? locoApikey : ""); }
  }

  const setSelectApikey = () => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) {
      const secret = JSON.parse(secretJson as string)
      const selectApikey = document.getElementById("apikey") as HTMLSelectElement;
      const option1 = document.createElement("option");
      option1.value = "";
      option1.textContent = "APIKeyを選択して下さい";
      selectApikey?.appendChild(option1)
      secret.forEach((element: { apikey: string; name: string | null; }) => {
          const option1 = document.createElement("option");
          option1.value = element.apikey;
          option1.textContent = element.name;
          selectApikey?.appendChild(option1)
      })
    }
  }

  useEffect(() => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) { setSelectApikey() }
    loadParams();
    loadApikey();
  },[])

  // close CSV popover on outside click
  useEffect(() => {
    const onClick = (ev: MouseEvent) => {
      if (csvRef.current && !csvRef.current.contains(ev.target as Node)) setCsvOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  // ---- active filter chips (UI only) ----
  type Chip = { key: string; label: string; value: string; clear: () => void };
  const activeChips: Chip[] = [
    apiKey ? { key: "apiKey", label: "ApiKey", value: "設定済み", clear: () => setApikey("") } : null,
    id ? { key: "id", label: "Id", value: id, clear: () => setId("") } : null,
    name ? { key: "name", label: "Name", value: name, clear: () => setName("") } : null,
    parent_id ? { key: "pid", label: "親Cluster", value: parent_id, clear: () => setParent_id("") } : null,
    tag ? { key: "tag", label: "Tag", value: tag, clear: () => setTag("") } : null,
    cm_per_pixel ? { key: "cmp", label: "Cm/Pixel", value: cm_per_pixel, clear: () => setCmPer("") } : null,
    att_coef ? { key: "att", label: "Att_Coef", value: att_coef, clear: () => setAtt("") } : null,
    enabled ? { key: "en", label: "Enabled", value: enabled === "false" ? "False" : "True", clear: () => setEnabled("") } : null,
    created_gt ? { key: "cgt", label: "Created ≥", value: created_gt, clear: () => setCreated_gt("") } : null,
    created_lt ? { key: "clt", label: "Created ≤", value: created_lt, clear: () => setCreated_lt("") } : null,
    updated_gt ? { key: "ugt", label: "Updated ≥", value: updated_gt, clear: () => setUpdated_gt("") } : null,
    updated_lt ? { key: "ult", label: "Updated ≤", value: updated_lt, clear: () => setUpdated_lt("") } : null,
    sort ? { key: "sort", label: "Sort", value: sort.toUpperCase(), clear: () => setSort("") } : null,
    (per_page) ? { key: "pp", label: "Per_Page", value: per_page, clear: () => setPer_Page("") } : null,
  ].filter(Boolean) as Chip[];

  const resetFilters = () => {
    setId(""); setName(""); setParent_id(""); setTag(""); setCmPer(""); setAtt(""); setEnabled("");
    setCreated_gt(""); setCreated_lt(""); setUpdated_gt(""); setUpdated_lt("");
    setSort(""); setPer_Page("");
  };

  return (
    <div className="bl-page">
      <Header current_page="ClusterMaster"/>

      <div className="bl-shell">
        {/* ---------- Sidebar: filters ---------- */}
        <aside className={"bl-aside" + (filterOpen ? "" : " collapsed")}>
          <div className="bl-aside-head">
            <span className="bl-aside-title"><Ico name="filter"/> 検索条件</span>
            <button type="button" className="bl-btn ghost sm icon" title={filterOpen ? "閉じる" : "開く"}
              onClick={() => setFilterOpen(o => !o)}>
              <Ico name={filterOpen ? "chevronLeft" : "chevronRight"}/>
            </button>
          </div>

          <form id="cm-filter-form" className="bl-aside-body" autoComplete="on" onSubmit={(e) => getCluster(e, 0)}>
            <button type="submit" className="bl-btn accent block lg" disabled={isFetching || isLoading}>
              {isFetching ? <><span className="bl-spin-sm" /> 検索中…</> : <><Ico name="search"/> 検索</>}
            </button>

            <div>
              <div className="bl-group-label">接続先</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">ApiKey</label>
                  <select id="apikey" className="bl-select" value={apiKey} onChange={(e) => setApikey(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">
                    <span>Per_Page</span>
                    <span className="bl-field-hint">既定5 / 最大1000</span>
                  </label>
                  <input className="bl-input" type="text" name="per_page" value={per_page}
                    placeholder="1ページ辺りの最大件数" onChange={(e) => setPer_Page(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">Id</label>
                  <input className="bl-input bl-mono" type="text" value={id} placeholder="Idを入力" onChange={(e) => setId(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">基本情報</div>
              <div className="bl-fields">
                <div><label className="bl-field-label">Name</label><input className="bl-input" value={name} placeholder="Nameを入力" onChange={(e) => setName(e.target.value)} /></div>
                <div><label className="bl-field-label">親クラスタのID</label><input className="bl-input bl-mono" value={parent_id} placeholder="親クラスタのIDを入力" onChange={(e) => setParent_id(e.target.value)} /></div>
                <div><label className="bl-field-label">Tag</label><input className="bl-input" value={tag} placeholder="Tagを入力" onChange={(e) => setTag(e.target.value)} /></div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">パラメータ</div>
              <div className="bl-grid-2">
                <div><label className="bl-field-label">Cm_Per_Pixel</label><input className="bl-input" value={cm_per_pixel} placeholder="値を入力" onChange={(e) => setCmPer(e.target.value)} /></div>
                <div><label className="bl-field-label">Att_Coef</label><input className="bl-input" value={att_coef} placeholder="値を入力" onChange={(e) => setAtt(e.target.value)} /></div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">状態</div>
              <select className="bl-select" value={enabled} onChange={e => setEnabled(e.target.value)}>
                <option value="">Enabled を指定</option>
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            </div>

            <div>
              <div className="bl-group-label">Created（作成時刻）</div>
              <div className="bl-fields">
                <div><label className="bl-field-label">以降 (gt)</label><input className="bl-input" type="datetime-local" step="1" value={created_gt} onChange={(e) => changeCreatedGt(e.target.value)} /></div>
                <div><label className="bl-field-label">以前 (lt)</label><input className="bl-input" type="datetime-local" step="1" value={created_lt} onChange={(e) => changeCreatedLt(e.target.value)} /></div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">Updated（更新時刻）</div>
              <div className="bl-fields">
                <div><label className="bl-field-label">以降 (gt)</label><input className="bl-input" type="datetime-local" step="1" value={updated_gt} onChange={(e) => changeUpdateGt(e.target.value)} /></div>
                <div><label className="bl-field-label">以前 (lt)</label><input className="bl-input" type="datetime-local" step="1" value={updated_lt} onChange={(e) => changeUpdateLt(e.target.value)} /></div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">並び順</div>
              <select className="bl-select" value={sort} onChange={e => setSort(e.target.value)}>
                <option value="">ASC / DESC を指定</option>
                <option value="asc">ASC（古い順）</option>
                <option value="desc">DESC（新着順）</option>
              </select>
            </div>

            <div className="bl-aside-actions">
              <button type="submit" className="bl-btn accent block lg" disabled={isFetching || isLoading}>
                {isFetching ? <><span className="bl-spin-sm" /> 検索中…</> : <><Ico name="search"/> 検索</>}
              </button>
              <button type="button" className="bl-btn block" onClick={resetFilters}>Reset</button>
            </div>
          </form>
        </aside>

        {/* ---------- Main ---------- */}
        <main className="bl-main">
          <div className="bl-section-head">
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {!filterOpen && (
                <button type="button" className="bl-btn ghost sm icon" title="検索条件を開く" onClick={() => setFilterOpen(true)}>
                  <Ico name="filter"/>
                </button>
              )}
              <h2>ClusterMaster</h2>
              {total >= 0 && <span className="bl-badge">{total.toLocaleString()} records</span>}
            </div>

            <div className="bl-toolbar">
              <div className="bl-pop-wrap" ref={csvRef}>
                <div className="bl-split">
                  <button type="button" className="bl-btn secondary" onClick={(e) => createCSV(e)} disabled={isFetching || isLoading}>
                    {isLoading
                      ? <><span className="bl-spin-sm" style={{ borderColor: "rgba(0,0,0,.15)", borderTopColor: "var(--bl-accent)" }} /> 出力中…</>
                      : <><Ico name="download"/> CSV出力</>}
                  </button>
                  <button type="button" className="bl-btn secondary" title="CSV出力オプション" onClick={() => setCsvOpen(o => !o)} disabled={isFetching || isLoading}>
                    <Ico name="chevronDown"/>
                  </button>
                </div>
                {csvOpen && (
                  <div className="bl-pop" style={{ width: 220 }}>
                    <div className="bl-pop-title">CSV出力に含める項目</div>
                    <label className="bl-pop-item">
                      <input type="checkbox" checked={isNoCheck} onChange={() => setNoCheck(p => !p)} /> no
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Active filters strip */}
          <div className="bl-chips">
            <span className="bl-chips-label">条件</span>
            {activeChips.length === 0 && <span className="bl-chips-empty">条件は未設定です</span>}
            {activeChips.map(c => (
              <span key={c.key} className="bl-chip">
                <span className="k">{c.label}</span>
                <span className="v bl-mono">{c.value}</span>
                <button type="button" className="x" title="削除" onClick={c.clear}><Ico name="close" size={10}/></button>
              </span>
            ))}
          </div>

          {/* Results */}
          <div className="bl-results-region">
            {(total > 0 && result.length > 0) ? (
              <>
                <Result result={result} />
                <div className="bl-footer">
                  <PageSelect pageNo={pageNo} lastPageNo={lastPageNo} getLog={getCluster} />
                </div>
              </>
            ) : (
              <div className="bl-empty">
                <Ico name="database" size={28} />
                <span className="big">{total === 0 ? "該当するデータがありません" : "ClusterMasterを検索"}</span>
                <span>{total === 0 ? "条件を変更して再検索してください" : "左の条件を指定して「検索」を押してください"}</span>
              </div>
            )}

            {(isFetching || isLoading) && (
              <div className="bl-overlay">
                <span className="bl-spin-lg" />
                <span>{isLoading ? "CSV出力中… しばらくお待ちください" : "読み込み中…"}</span>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  )
}

/* inline icon set — no extra deps */
const Ico = ({ name, size = 14 }: { name: string; size?: number }) => {
  const paths: Record<string, JSX.Element> = {
    filter: <path d="M3 5h18l-7 9v6l-4-2v-4L3 5Z" />,
    search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m7 10 5 5 5-5" /><path d="M12 15V3" /></>,
    close: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
    chevronLeft: <path d="m15 18-6-6 6-6" />,
    chevronRight: <path d="m9 18 6-6-6-6" />,
    chevronDown: <path d="m6 9 6 6 6-6" />,
    database: <><ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M3 5v14a9 3 0 0 0 18 0V5" /><path d="M3 12a9 3 0 0 0 18 0" /></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      {paths[name]}
    </svg>
  );
};

export default ClusterMaster